import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import MasteryTestListItemsService from './MasteryTestListItemsService';

class CreateMasteryTestItemDraftDialogService {
  form = new FormService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      masteryTestItem: null,
    });
    this.form.validations = {
      draftCreationReason: [isRequired],
    };
  }

  init = action(() => {
    this.form.reset();
    this.isOpen = false;
    this.masteryTestItem = null;
  });

  handleShow = action((masteryTestItem) => {
    this.masteryTestItem = masteryTestItem;
    this.isOpen = true;
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.masteryTestItem = null;
    this.form.reset();
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    this.submit
      .fetch({
        method: 'post',
        url: `/mastery-tests/${this.masteryTestItem.masteryTest}/items/${this.masteryTestItem.item.id}/draft`,
        body: {
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Drat successfully created', 'success');
          MasteryTestListItemsService.handleLoad();
          this.handleClose();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error to create draft', 'error');
        }
      });
  });
}

const createMasteryTestItemDraftDialogService = new CreateMasteryTestItemDraftDialogService();

export default createMasteryTestItemDraftDialogService;
